#import "./availability-report-day-fragment.graphql"

fragment AvailabilityReportFragment on AvailabilityReport {
    id
    days {
        ...AvailabilityReportDayFragment
    }
}
